<div class="header">
  <div class="dialog-outer-box">
    <div class="text-box">
      <span class="text-content">You have logged out of the activity. <br/>
      Close this tab and return to the Apprize app.
      </span>
    </div>
  </div>
</div>
